import React from "react";
import InfoBox from '../components/info.js'
import Panoramic from "../components/panoramic.js";
import PhotoBas from './../../images/A5-Bas-de-page.jpg'

export default () => (
    <Panoramic>
        <div className='metadata--wrapper'>
            <img src={PhotoBas} alt="" />
            <InfoBox>Habitations près d&#39;un affluent d&#39;eau. Dessin anonyme, Fond de la famille Picard de Wendake, <br/>BAnQ, sans date. Habitation près d&#39;un affluent d&#39;eau. Dessin de Paul Picard, Fond de la famille Picard de Wendake, BAnQ, 1864.</InfoBox>
        </div>
    </Panoramic>
);



// WEBPACK FOOTER //
// ./src/components/image-footer-axe5.js